<template>
  <v-app>
    <AppToolbar v-if="isInitialized" />

    <AppDrawer v-if="isInitialized" />
    <AppView />
  </v-app>
</template>
<script>
import {
  AppToolbar,
  AppDrawer,
  AppView
} from './components/layout'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    AppToolbar, AppDrawer, AppView
  },
  computed: {
    ...mapState('app', ['user', 'initialized']),
    ...mapGetters('auth', ['isAuthenticated']),
    isInitialized () {
      return this.initialized && this.isAuthenticated
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/index.scss';
:root {
  --metal-blue-l: #e5efff;
  --metal-blue: #3f6fb6;
  --metal-blue-d: #365e99;
  --tertiary: #495057;
  --metal-brown: #795548;
  --metal-grey: #777;
  --metal-grey-d: #555;
  --metal-white: #fff;
  --metal-orange: #d2891d;
}
</style>
